import(/* webpackMode: "eager" */ "/codebuild/output/src339089010/src/src/app/[locale]/page.tsx");
